module.exports = __webpack_public_path__ + "static/media/suisseintl-semibold-webm.a106a91c.woff";